import {Reducer} from 'redux';
import {State} from '../model/State';
import {IAction} from '../model/IAction';
import {ITaskData} from '../model/IProcessData';

import * as FetchActions from '../actions/FetchDataItems';

export function tasks(state: ITaskData[] = [], action: IAction): ITaskData[] {
    switch (action.type) {
        case FetchActions.RECEIVE_TASKS:
            const receiveAction = action as FetchActions.IReceiveTasksAction;
            let stateCopy: ITaskData[] = Object.assign([], state);
            stateCopy = stateCopy.concat(receiveAction.tasksData)
            return stateCopy;
        default:
            return state;
    }
}

